module.exports = __webpack_public_path__ + "img/logo.b603b99c.svg";